import { CANAL_LABEL, type CanalTotal } from '../../lib/api.js';
import { fmtInt, fmtPct } from '../../lib/format.js';
import { CANAL_COLORS } from './ChartCard.js';

/**
 * Mix de canales del período en UNA barra al 100 %.
 *
 * La pregunta que responde («cuánto de lo vendido entra por cada canal») es una
 * comparación de partes de un todo con cinco categorías: una barra apilada
 * horizontal la contesta de un vistazo y deja sitio para rotular cada tramo
 * directamente, así que la identidad no depende solo del color.
 *
 * Los tramos por debajo del 7 % no se rotulan dentro (no cabe el texto sin
 * pisarse): su cifra vive en la fila de abajo, que es también la vista tabular.
 */
export function CanalesMixBar({ porCanal, total }: { porCanal: CanalTotal[]; total: number }) {
  const conNoches = porCanal.filter((c) => c.noches > 0);
  if (total <= 0 || conNoches.length === 0) {
    return <p className="text-sm text-slate-500">Sin noches cargadas en el período.</p>;
  }

  return (
    <div className="space-y-3">
      <div className="flex h-9 w-full gap-[2px] overflow-hidden rounded">
        {conNoches.map((c) => {
          const frac = c.noches / total;
          return (
            <div
              key={c.canal}
              className="flex items-center justify-center overflow-hidden text-[11px] font-medium text-slate-950"
              style={{ width: `${frac * 100}%`, backgroundColor: CANAL_COLORS[c.canal] }}
              title={`${CANAL_LABEL[c.canal]}: ${fmtInt(c.noches)} noches`}
            >
              {frac >= 0.07 ? fmtPct(frac * 100) : ''}
            </div>
          );
        })}
      </div>

      <ul className="flex flex-wrap gap-x-5 gap-y-1 text-xs">
        {porCanal.map((c) => (
          <li key={c.canal} className="flex items-center gap-1.5">
            <span
              aria-hidden
              className="inline-block h-2.5 w-2.5 rounded-sm"
              style={{ backgroundColor: CANAL_COLORS[c.canal] }}
            />
            <span className="text-slate-300">{CANAL_LABEL[c.canal]}</span>
            <span className="tabular-nums text-slate-400">{fmtInt(c.noches)}</span>
            <span className="tabular-nums text-slate-500">
              ({c.share == null ? '—' : fmtPct(c.share * 100)})
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
